import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleNav } from "../../redux/actions/miscActions";
import { getAllProducts, getAllPakketten } from '../../redux/actions/productActions'
import { getAllOrders } from '../../redux/actions/orderActions'
import { getAllCartData } from '../../redux/actions/cartActions'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
} from "react-router-dom";
import Navbar from "./layout/Navbar";
import Dashboard from "./components/Dashboard";
import Products from "./components/Products";
import Orders from "./components/Orders";
import Pakketten from "./components/Pakketten";

export class Admin extends Component {
  componentDidMount = () => {
    this.props.getAllProducts()
    this.props.getAllOrders()
    this.props.getAllPakketten()
    this.props.toggleNav(false);
  };

  componentWillUnmount = () => {
    this.props.toggleNav(true);
  };
  
  render() {
    return (
      <div className="admin-page">
        <Router>
          <Navbar />
         
          <Switch>           
            <Route exact path="/admin/dashboard" component={Dashboard} />            
            <Route exact path="/admin/products" component={Products} />
            <Route exact path="/admin/orders" component={Orders} />
            <Route exact path="/admin/pakketten" component={Pakketten} />
          </Switch>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  misc: state.misc
});

export default connect(mapStateToProps, { toggleNav, getAllProducts, getAllOrders, getAllCartData, getAllPakketten })(withRouter(Admin));
